module.exports = __webpack_public_path__ + "img/202311_08.739eea40.jpg";